import React from "react";
import { useSelector } from "react-redux";
import { Paper, Typography, Box } from "@mui/material";
import UtilityTemplate from "../../../../Images/Templates/first preview/utility.png";
import MarketingTemplate from "../../../../Images/Templates/first preview/marketing.png";
import AuthenticationTemplate from "../../../../Images/Templates/first preview/authentication.png";

// Sample images for different categories
const categoryImages = {
  Marketing: MarketingTemplate,
  Utility: UtilityTemplate,
  Authentication: AuthenticationTemplate,
};

// Sample details for different categories
const categoryDetails = {
  Marketing: {
    goodFor:
      "Welcome messages, promotions, offers, coupons, newsletters, announcements",
    customizableAreas: "Header, body, footer, button",
  },
  Utility: {
    goodFor:
      "Order confirmations, account updates, receipts, appointment reminders, billing",
    customizableAreas: "Header, body, footer, button",
  },
  Authentication: {
    goodFor:
      "One-time password, account recovery code, account verification, integrity challenges",
    customizableAreas: "Code delivery method",
  },
};

const TemplateSetupPreview = () => {
  const selectedCategory = useSelector(
    (state) => state.templateCreation.selectedCategory
  );

  const { goodFor, customizableAreas } = categoryDetails[selectedCategory];

  return (
    <Paper
      elevation={1}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "100%",
        padding: '10px',
        backgroundColor: (theme) => theme.palette.background.paper,
        boxShadow: (theme) =>
          theme.palette.mode === "dark"
        ? "0px 4px 6px rgba(0, 0, 0, 0.2)"
        : "0px 4px 6px rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
        textAlign: "left",
      }}
    >
      <Typography
        variant="h6"
        marginBottom={1}
        textAlign="center"
        sx={{ color: (theme) => theme.palette.text.primary }}
      >
        {selectedCategory} Preview
      </Typography>

      <Box
        component="img"
        src={categoryImages[selectedCategory]}
        alt={`${selectedCategory} Template preview`}
        sx={{
          width: "100%",
          maxHeight: "350px",
          maxWidth: "300px",
          objectFit: "fit",
          borderRadius: 2,
          marginBottom: 3,
        }}
      />

      <Box sx={{ textAlign: "left" }}>
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          marginBottom={1}
          sx={{ color: (theme) => theme.palette.text.primary }}
        >
          This template is good for
        </Typography>
        <Typography
          variant="body1"
          marginBottom={2}
          sx={{ color: (theme) => theme.palette.text.secondary }}
        >
          {goodFor}
        </Typography>

        <Typography
          variant="subtitle1"
          fontWeight="bold"
          marginBottom={1}
          sx={{ color: (theme) => theme.palette.text.primary }}
        >
          Template areas you can customize
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: (theme) => theme.palette.text.secondary }}
        >
          {customizableAreas}
        </Typography>
      </Box>
    </Paper>
  );
};

export default TemplateSetupPreview;
